import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class DashboardInvitesRoute extends Route {
  @service session;
  @service router;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    if (!this.session.currentUser?.isIndividual) {
      this.router.replaceWith("dashboard");
    }
  }

  model() {
    return this.session.currentUser.get("invites").reload();
  }
}
